
<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between create-order-header">
  <div class="my-auto">
    <div class="d-flex create-order-title-wrap">
      <h4 class="content-title mb-0 my-auto">Crear Paquete</h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">Transacciones / Documentos Electrónicos</span>
  </div>
</div>
<div class="d-flex my-xl-auto right-content mr-2">

  <div class="mb-0 mb-xl-0 order-actions">
    <div ngbDropdown class="btn-group method-dropdown">

      <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle-split"
        id="dropdownMenuDate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{metodosPagos}}

      </button>
      <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="dropdownMenuDate"
        data-x-placement="bottom-end">
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('EFECTIVO')">EFECTIVO</a>
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('TARJETA DE DEBITO')">TARJETA DE
        DEBITO</a>
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('TARJETA DE CREDITO')">TARJETA DE
        CREDITO</a>
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('TRANSFERENCIA')">TRANSFERENCIA</a>
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('CREDITO')">CRÉDITO</a>
        <a ngbDropdownItem href="javascript:;" (click)="changeMetodoPago('PAGO MULTIPLE')">MULTIPLES PAGOS</a>

      </div>
    </div>
    <div class="mobile-inline-actions">
      <button type="button" class="btn btn-primary" (click)="modalGuardarTransaccion(mdlAbrirModalGuardar)">
        <i class="icon ion-ios-filing"></i> GUARDAR
      </button>
      <button type="button" class="btn btn-light" (click)="volverAtras()">VOLVER</button>
    </div>
    <div class="d-none d-md-flex desktop-action-buttons">
      <button type="button" class="btn btn-primary" (click)="modalGuardarTransaccion(mdlAbrirModalGuardar)"><i class="icon ion-ios-filing"></i> GUARDAR</button>
      <button type="button" class="btn btn-light" (click)="volverAtras()">VOLVER</button>
    </div>
  </div>
</div>
</div>
<div class="row row-sm">

  <!-- ── Desktop: dos tarjetas lado a lado ─────────────────────────────── -->
  <div class="col-md-6 d-none d-md-block">
    <div class="card">
      <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">Datos del paciente</h6>
      <div class="card-body">
        <div class="mb-2">
          <div class="form-row selection-row">
            <ng-select class="form-control" id="seleccionarClienteInput" name="seleccionarClienteInput"
              placeholder="Ingrese cédula, nombre, apellido..." name="country"
              (keydown)="buscarPaciente($event)" [(ngModel)]='selected' (keyup)="buscarPaciente($event)"
              (change)="obtenerClienteSeleccionado(selected)">
              @for (obj of pacienteslist; track obj) {
                <ng-option [value]="obj.codigo">{{obj.datos}}</ng-option>
              }
            </ng-select>
            <button type="button" class="btn-outline-primary btn-sm" id="btnAgregarClient" (click)="modalAgregarPaciente(mdlAgregarPaciente)"><b>Agregar</b></button>
            @if (idPaciente!='') {
              <button type="button" class="btn-outline-light btn-sm" id="btnEditarClient" (click)="modalEditarPaciente(mdlEditarPaciente)" data-backdrop="static" data-keyboard="false"><b>Editar</b></button>
            }
          </div>
          <hr>
            <b>Nombre:</b>&nbsp;{{nombre}}<br>
            <b>Cédula o Ruc:</b>&nbsp;{{identificacion}}<br>
            <b>Télefono:</b>&nbsp;{{telefono}} @if (mTelefonoDoctor) {
            <input type="text" [(ngModel)]='nuevoTelefonoEnCardP' mask="000 000 0000" id="txtTelf" style="width:40%">
          }
          <button type="button" id="btnEditarCel" (click)="mostrarInputTelefono()"><i class="si si-pencil" id="iconEdit"></i></button>&nbsp;@if (nuevoTelefonoEnCardP.length<10 && mTelefonoDoctor) {
          <span class="text-danger">El número debe contener 10 digitos</span>
          }<br>
          <b>Dirección: </b>&nbsp;{{direccion}}<br>
          <b>Fec. Nac.:</b>&nbsp;{{fechaNacimiento}}<br>
          <b>Correo Electrónico:</b>&nbsp;{{email}}<br>
          <b>Observaciones Paciente: </b>
          <textarea class="form-control" rows="3" [(ngModel)]='observacionesPaciente'></textarea>
          @if (identificacionAdicional!='' && identificacionAdicional!='null' && identificacionAdicional!=null) {
            <ngb-alert class="alert show alert-info fade alert-dismissible" type="">
              FACTURAR A OTROS DATOS: {{identificacionAdicional}} - {{nombreAdicional}}
            </ngb-alert>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 d-none d-md-block">
    <div class="card">
      <h6 class="card-title text-uppercase p-2 text-white mb-1" style="background-color:#2E3D8C">Datos del doctor</h6>
      <div class="card-body">
        <div class="mb-2">
          @if (contenedorDoctor) {
            <div class="form-row selection-row">
              <ng-select class="form-control" placeholder="Ingrese cédula, nombre, apellido..." name="country"
                (keydown)="buscarDoctor($event)" [(ngModel)]='selectedDoctor' (keyup)="buscarDoctor($event)"
                (change)="obtenerDoctorSeleccionado(selectedDoctor)">
                @for (obj of doctoreslist; track obj) {
                  <ng-option [value]="obj.codigo">{{obj.datos}}</ng-option>
                }
              </ng-select>
            </div>
          }
          @if (!contenedorDoctor) {
            <div class="form-row">
              <input class="form-control" placeholder="Ingrese cédula, nombre, apellido..." disabled>
            </div>
          }
          <hr>
            <b>Nombre:</b>&nbsp;{{nombreDoctor}}<br>
            <b>Télefono:</b>&nbsp;{{telefonoDoctor}}&nbsp;@if (editarTelefonoDoctor) {
            <input type="text" id="txtTelf1" mask="000 000 0000" [(ngModel)]='nuevoTelefonoEnCardD' style="width:40%">
          }
          <button type="button" id="btnEditarCel1" (click)="cambiarEstadoEdiTelDoc()"><i class="si si-pencil" id="iconEdit1"></i></button>&nbsp;@if (nuevoTelefonoEnCardD.length<10 && editarTelefonoDoctor) {
          <span class="text-danger">El número debe contener 10 digitos</span>
          }<br>
          <b>Dirección: </b>&nbsp;{{direccionDoctor}}<br>
          <b>Correo Electrónico:</b>&nbsp;{{emailDoctor}}<br>
          <b>Asesor:</b>&nbsp;{{asesorDoctor}}<br>
          <input type="checkbox" value="Orden Fisica" id="checkOrdenesFisicas" [(ngModel)]='checkSolicitarOrdn' (change)="modalSolicitarOF(mdlAsginarSecuenciaFisica)"> Solicitar ordenes fisicas<br>
          <input type="checkbox" value="Capacitacion" id="checkCapacitacion" (change)="modalSolicitarCapacitacion(mdlSolicitarCapacitacion)"> Solicitar Capacitacion
        </div>
      </div>
    </div>
  </div>

  <!-- ── Móvil: una sola tarjeta con pestañas ──────────────────────────── -->
  <div class="col-12 d-md-none">
    <div class="card mobile-tab-card">
      <div class="mobile-tabs-header">
        <button class="mobile-tab-btn" [class.active]="mobileTab==='paciente'" (click)="mobileTab='paciente'">
          <i class="fa fa-user"></i> Paciente
        </button>
        <button class="mobile-tab-btn" [class.active]="mobileTab==='doctor'" (click)="mobileTab='doctor'">
          <i class="fa fa-user-md"></i> Doctor
        </button>
      </div>

      <!-- Pestaña Paciente -->
      @if (mobileTab==='paciente') {
        <div class="card-body mobile-tab-body">
          <div class="form-row selection-row">
            <ng-select class="form-control" placeholder="Cédula, nombre, apellido..."
              (keydown)="buscarPaciente($event)" [(ngModel)]='selected' (keyup)="buscarPaciente($event)"
              (change)="obtenerClienteSeleccionado(selected)">
              @for (obj of pacienteslist; track obj) {
                <ng-option [value]="obj.codigo">{{obj.datos}}</ng-option>
              }
            </ng-select>
            <div class="mobile-tab-actions">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="modalAgregarPaciente(mdlAgregarPaciente)">Agregar</button>
              @if (idPaciente!='') {
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="modalEditarPaciente(mdlEditarPaciente)" data-backdrop="static" data-keyboard="false">Editar</button>
              }
            </div>
          </div>
          @if (nombre) {
            <div class="compact-info mt-2">
              <div><b>Nombre:</b> {{nombre}}</div>
              <div><b>Cédula:</b> {{identificacion}}</div>
              <div>
                <b>Tel:</b> {{telefono}}
                @if (mTelefonoDoctor) {
                  <input type="text" [(ngModel)]='nuevoTelefonoEnCardP' mask="000 000 0000" id="txtTelf" class="compact-phone-input">
                }
                <button type="button" (click)="mostrarInputTelefono()"><i class="si si-pencil"></i></button>
              </div>
              @if (nuevoTelefonoEnCardP.length<10 && mTelefonoDoctor) {
                <span class="text-danger">El número debe contener 10 dígitos</span>
              }
            </div>
          }
          @if (nombre) {
            <details class="mobile-details mt-2">
              <summary>Ver más datos</summary>
              <div class="compact-info mt-1">
                <div><b>Dirección:</b> {{direccion}}</div>
                <div><b>Fec. Nac.:</b> {{fechaNacimiento}}</div>
                <div><b>Correo:</b> {{email}}</div>
              </div>
              <textarea class="form-control mt-1" rows="2" [(ngModel)]='observacionesPaciente' placeholder="Observaciones..."></textarea>
              @if (identificacionAdicional!='' && identificacionAdicional!='null' && identificacionAdicional!=null) {
                <ngb-alert class="alert show alert-info fade alert-dismissible mt-1" type="">
                  FACTURAR A: {{identificacionAdicional}} - {{nombreAdicional}}
                </ngb-alert>
              }
            </details>
          }
        </div>
      }

      <!-- Pestaña Doctor -->
      @if (mobileTab==='doctor') {
        <div class="card-body mobile-tab-body">
          @if (contenedorDoctor) {
            <div class="form-row selection-row">
              <ng-select class="form-control" placeholder="Cédula, nombre, apellido..."
                (keydown)="buscarDoctor($event)" [(ngModel)]='selectedDoctor' (keyup)="buscarDoctor($event)"
                (change)="obtenerDoctorSeleccionado(selectedDoctor)">
                @for (obj of doctoreslist; track obj) {
                  <ng-option [value]="obj.codigo">{{obj.datos}}</ng-option>
                }
              </ng-select>
              <div class="mobile-tab-actions">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="modalAgregarDoctor(mdlAgregarDoctor)">Agregar</button>
              </div>
            </div>
          }
          @if (!contenedorDoctor) {
            <div class="form-row">
              <input class="form-control" placeholder="Ingrese cédula, nombre, apellido..." disabled>
            </div>
          }
          @if (nombreDoctor) {
            <div class="compact-info mt-2">
              <div><b>Nombre:</b> {{nombreDoctor}}</div>
              <div>
                <b>Tel:</b> {{telefonoDoctor}}
                @if (editarTelefonoDoctor) {
                  <input type="text" id="txtTelf1" mask="000 000 0000" [(ngModel)]='nuevoTelefonoEnCardD' class="compact-phone-input">
                }
                <button type="button" (click)="cambiarEstadoEdiTelDoc()"><i class="si si-pencil"></i></button>
              </div>
              @if (nuevoTelefonoEnCardD.length<10 && editarTelefonoDoctor) {
                <span class="text-danger">El número debe contener 10 dígitos</span>
              }
            </div>
          }
          @if (nombreDoctor) {
            <details class="mobile-details mt-2">
              <summary>Ver más datos</summary>
              <div class="compact-info mt-1">
                <div><b>Dirección:</b> {{direccionDoctor}}</div>
                <div><b>Correo:</b> {{emailDoctor}}</div>
                <div><b>Asesor:</b> {{asesorDoctor}}</div>
              </div>
              <label class="d-block mt-1">
                <input type="checkbox" [(ngModel)]='checkSolicitarOrdn' (change)="modalSolicitarOF(mdlAsginarSecuenciaFisica)"> Solicitar ordenes fisicas
              </label>
              <label class="d-block">
                <input type="checkbox" (change)="modalSolicitarCapacitacion(mdlSolicitarCapacitacion)"> Solicitar Capacitacion
              </label>
            </details>
          }
        </div>
      }
    </div>
  </div>

  <div class="col-md-12">
    <div class="card">
      <h6 class="card-title text-uppercase p-2  text-white mb-1" style="background-color:#2E3D8C">
        detalle de la orden
      </h6>


      <div class="card-body">
        <div class="form-row">
          @if (codigoDoctor!='') {
            <div class="col-md-12 specialties-grid">
              @for (obj of especialidadesOrdenlist; track obj; let i = $index) {
                <div class="btn-group specialty-item"
                  [class.specialty-hidden]="!showAllSpecialties && i >= 6">
                  <button class="btn btn-outline-primary btn-rounded btn-block" (click)="modalEscogerServicio(mdlBuscarServicios,obj.datos )"> {{ limpiarTitulo(obj.datos) }}</button>
                </div>
              }
              @if (especialidadesOrdenlist.length > 6) {
                <div class="d-md-none specialty-toggle-wrap">
                  <button class="btn btn-sm specialty-toggle-btn" (click)="showAllSpecialties = !showAllSpecialties">
                    <i class="fa" [class.fa-chevron-down]="!showAllSpecialties" [class.fa-chevron-up]="showAllSpecialties"></i>
                    {{ showAllSpecialties ? 'Ver menos' : 'Ver más (' + (especialidadesOrdenlist.length - 6) + ')' }}
                  </button>
                </div>
              }
              <hr>
             
                <div class="d-flex align-items-center gap-3 m-2">
                  <label class="d-flex align-items-center gap-1">
                    <input type="checkbox"
                      (change)="toggleAllReservations($event)"
                      [checked]="allSelected">
                    Marcar/Desmarcar Todas
                  </label>
                 
                </div>
                <!-- ── Desktop: tabla clásica ────────────────────────────────────── -->
                <div class="d-none d-md-block">
                  <div class="table-responsive order-detail-table-wrapper">
                    <table  class="table table-striped tablaServicioOrden" width="100%">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Servicio</th>
                          <th>Observación</th>
                          <th>Valor</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="servicios">
                        @for (dynamic of detalleOrden; track dynamic; let i = $index) {
                          <tr>
                            <td> {{i+1}}</td>
                            <td><textArea type="text" class="form-control textWidth producto" readonly> {{detalleOrden[i]?.producto}} </textArea>
                          </td>
                          <td><textArea type="text" class="form-control textWidth descripcion" name="nombre" (change)="changeObservacion($event,i);">{{detalleOrden[i]?.pieza}}</textArea></td>
                          <td>
                            <select class="form-control" (change)="changeRow(i, $event)">
                              @for (p of detalleOrden[i]?.preciosSelect || []; track p) {
                                <option [value]="p.precio" [selected]="convertirFloat(p.precio) === detalleOrden[i]?.precioSeleccionado">{{p.porcentaje}}{{convertirFloat(p.precio)}}</option>
                              }
                            </select>
                            <p class="text-success">IMPUESTO: {{detalleOrden[i]?.impuesto}},  {{detalleOrden[i]?.impuesto == "12" ? "INCLUYE IVA: "+detalleOrden[i]?.incluidoIva+", ": ""}}    PRECIO FINAL: {{detalleOrden[i]?.impuesto == "0" ? detalleOrden[i]?.precioSeleccionado : detalleOrden[i]?.impuesto == "12" && detalleOrden[i]?.incluidoIva == "SI" ? convertirFloat(detalleOrden[i]?.precioSeleccionado) : convertirFloat(detalleOrden[i]?.precioSeleccionado * 1.12)   }}</p>
                          </td>
                          <td><button class="btn btn-danger quitarProducto" (click)="deleteRow(i)"><i class="fa fa-times"></i></button></td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- ── Móvil: tarjetas por servicio ─────────────────────────────── -->
              <div class="d-md-none service-cards-list">
                @if (detalleOrden.length === 0) {
                  <div class="service-cards-empty">Sin servicios agregados</div>
                }
                @for (item of detalleOrden; track item; let i = $index) {
                  <div class="service-card">
                    <div class="service-card-header">
                      <span class="service-card-num">{{i+1}}</span>
                      <span class="service-card-name">{{item.producto}}</span>
                      <button class="btn btn-sm btn-danger service-card-del" (click)="deleteRow(i)"><i class="fa fa-times"></i></button>
                    </div>
                    <div class="service-card-body">
                      <select class="form-control form-control-sm" (change)="changeRow(i, $event)">
                        @for (p of item.preciosSelect; track p) {
                          <option [value]="p.precio" [selected]="convertirFloat(p.precio) === item.precioSeleccionado">{{p.porcentaje}}{{convertirFloat(p.precio)}}</option>
                        }
                      </select>
                      <div class="service-card-tax">
                        IMP: {{item.impuesto}}%@if (item.impuesto=='12') {
                        &nbsp;|&nbsp; IVA: {{item.incluidoIva}}
                      }
                      &nbsp;|&nbsp; <b>FINAL: {{item.impuesto == "0" ? item.precioSeleccionado : item.impuesto == "12" && item.incluidoIva == "SI" ? convertirFloat(item.precioSeleccionado) : convertirFloat(item.precioSeleccionado * 1.12)}}</b>
                    </div>
                    <div class="service-card-checks">
                      <label><input type="checkbox" (change)="changeReserva($event, item.reserved, i)" [checked]="item.reserved"> Reservar</label>
                    </div>
                    <textarea class="form-control form-control-sm" rows="2" placeholder="Observación..." (change)="changeObservacion($event, i)">{{item.pieza}}</textarea>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="col-lg-6 col-xl-6 col-xxl-6 col-md-6 col-12">
          <div class="card custom-card">
            <div class="card-body pb-3">

              <p  class="mb-2 tx-12">SUBTOTAL IMPUESTO: <input class="form-control" type="text"
              [(ngModel)]='subtotalImpuesto' readonly></p>

              <p class="mb-2 tx-12">SUBTOTAL SIN IMPUESTO: <input class="form-control" type="text"
              [(ngModel)]='subtotalSinImpuesto' readonly></p>


              <br>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 col-xxl-6 col-md-6 col-12">
            <div class="card custom-card">
              <div class="card-body pb-3">

                <p  class="mb-2 tx-12">SUBTOTAL: <input class="form-control" [(ngModel)]='subtotal'
                type="text" readonly></p>

                <p  class="mb-2 tx-12">IVA 12%: <input class="form-control" [(ngModel)]='iva' type="text"
                readonly></p>

                <p  class="mb-2 tx-12">TOTAL: <input class="form-control" [(ngModel)]='total' type="text"
                readonly></p>





              </div>
            </div>
          </div>




        </div>

      </div>



    </div>
  </div>

</div>

<div class="mobile-action-bar">
  <button type="button" class="mobile-fab mobile-fab--back" (click)="volverAtras()">
    <i class="fa fa-arrow-left"></i>
    <span>Volver</span>
  </button>
  <button type="button" class="mobile-fab mobile-fab--save" (click)="modalGuardarTransaccion(mdlAbrirModalGuardar)">
    <i class="fa fa-save"></i>
    <span>Guardar</span>
  </button>
</div>



<!-- ----------------------------------------------------------------------- -->
<!--                         MODAL AGREGAR PACIENTE                          -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #mdlAgregarPaciente let-modal>
  <div class="modal-header">
    <h6 class="modal-title">INGRESAR NUEVO PACIENTE</h6>
    <button type="button" class="close" aria-label="Close" (click)="cerrarModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <!-- ¿Tiene identificación? -->
    <div class="modal-field-group">
      <b>¿Tiene número de identificación?</b>
      <div class="modal-check-row mt-1">
        <label><input type="checkbox" [(ngModel)]="checkIdentificacionSI" (change)="cambiarSIIdent()"> &nbsp;Sí</label>
        <label><input type="checkbox" [(ngModel)]="checkIdentificacionNO" (change)="cambiarNOIdent()"> &nbsp;No</label>
      </div>
    </div>

    @if (spinnerBooleanBuscarData) {
      <div class="text-center py-2">
        <div class="spinner-grow" role="status"><span class="sr-only">Loading...</span></div>
        <p class="mb-0 mt-1">Cargando, por favor espere...</p>
      </div>
    }

    @if (checkIdentificacionNO) {
      <div class="modal-field-group">
        <b>IDENTIFICACIÓN</b>
        <input type="text" class="form-control" placeholder="Identificación generada" [(ngModel)]='randomCedula' readonly>
      </div>
    }

    @if (checkIdentificacionSI) {
      <div class="form-row">
        <div class="col-6 modal-field-group">
          <b>TIPO ID</b>
          <ng-select class="form-control" [(ngModel)]='nuevaIdentificacionPaciente' placeholder="Tipo...">
            <ng-option value="">Seleccione...</ng-option>
            <ng-option value="05">CÉDULA</ng-option>
            <ng-option value="04">RUC</ng-option>
            <ng-option value="06">PASAPORTE</ng-option>
            <ng-option value="08">EXTERIOR</ng-option>
          </ng-select>
          @if (nuevaIdentificacionPaciente=='') {
            <p class="text-danger">Requerido</p>
          }
        </div>
        <div class="col-6 modal-field-group">
          <b>IDENTIFICACIÓN</b>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Número" [(ngModel)]='identificacionPaciente'>
            <button class="btn btn-light" (click)="buscarDataPersonas('agregar')"><i class="mdi mdi-account-search"></i></button>
          </div>
          @if (identificacionPaciente=='') {
            <p class="text-danger">Requerido</p>
          }
        </div>
      </div>
    }

    <div class="modal-field-group">
      <b>NOMBRE</b>
      <input type="text" class="form-control" placeholder="Nombre completo" [(ngModel)]='nombrePaciente'>
      @if (nombrePaciente=='') {
        <p class="text-danger">Requerido</p>
      }
    </div>

    <div class="form-row">
      <div class="col-6 modal-field-group">
        <b>FECHA NAC.</b>
        <input type="date" class="form-control" (change)="cambiarFechaNacimiento()" [(ngModel)]='fechaNacimientoPaciente'>
        @if (fechaNacimientoPaciente=='') {
          <p class="text-danger">Requerido</p>
        }
      </div>
      <div class="col-6 modal-field-group">
        <b>EDAD</b>
        <input type="number" class="form-control" [(ngModel)]='nuevaEdadPaciente' readonly>
      </div>
    </div>

    <div class="form-row">
      <div class="col-6 modal-field-group">
        <b>SEXO</b>
        <ng-select class="form-control" placeholder="Sexo..." [(ngModel)]='sexoPaciente'>
          <ng-option value="">Seleccione...</ng-option>
          <ng-option value="masculino">MASCULINO</ng-option>
          <ng-option value="femenino">FEMENINO</ng-option>
          <ng-option value="persona-juridica">PERSONA JURÍDICA</ng-option>
          <ng-option value="otro">OTROS</ng-option>
        </ng-select>
        @if (sexoPaciente=='') {
          <p class="text-danger">Requerido</p>
        }
      </div>
      <div class="col-6 modal-field-group">
        <b>DIRECCIÓN</b>
        <input type="text" class="form-control" placeholder="Dirección" [(ngModel)]='direccionPaciente'>
      </div>
    </div>

    <!-- ¿Tiene teléfono? -->
    <div class="modal-field-group">
      <b>¿Tiene número de teléfono?</b>
      <div class="modal-check-row mt-1">
        <label><input type="checkbox" [(ngModel)]="checkTelefonoSI" (change)="cambiarSITelef()"> &nbsp;Sí</label>
        <label><input type="checkbox" [(ngModel)]="checkTelefonoNO" (change)="cambiarNOTelf()"> &nbsp;No</label>
      </div>
    </div>

    @if (checkTelefonoSI) {
      <div class="form-row">
        <div class="col-6 modal-field-group">
          <b>PAÍS</b>
          <ng-select class="form-control" [(ngModel)]='pais' (change)="cambiarPais()">
            @for (obj of paisesList; track obj) {
              <ng-option [value]="obj.id+'|'+obj.codigo+'|'+obj.estructura">
                {{obj.nombre}}
              </ng-option>
            }
          </ng-select>
        </div>
        <div class="col-6 modal-field-group">
          <b>TELÉFONO</b>
          <input type="text" class="form-control" placeholder="Número" [(ngModel)]='nuevoTelefonoCliente' mask="{{inputMaskPais}}">
          @if (nuevoTelefonoCliente=='') {
            <p class="text-danger">Requerido</p>
          }
        </div>
      </div>
    }

    <div class="modal-field-group">
      <b>EMAIL</b>
      <input type="email" class="form-control" placeholder="correo@ejemplo.com" [(ngModel)]='nuevoEmailPaciente'>
      @if (nuevoEmailPaciente=='') {
        <p class="text-danger">Requerido</p>
      }
    </div>

    <hr class="my-2">

    <!-- Facturación adicional -->
    <div class="modal-check-row">
      <label><input type="checkbox" [(ngModel)]="checkFacturarOtrasPersonasSI" (change)="cambiarFacturarOtraPersona()"> &nbsp;Facturar a otra persona</label>
      <label><input type="checkbox" [(ngModel)]="checkConsumidorFinalNO" (change)="cambiarConsumidorFinal()"> &nbsp;Consumidor final</label>
    </div>

    @if (checkFacturarOtrasPersonasSI || checkConsumidorFinalNO) {
      <div>
        <div class="modal-field-group mt-2">
          <b>TIPO ID FACTURACIÓN</b>
          <ng-select class="form-control" placeholder="Tipo documento..." [(ngModel)]="nuevaIdentificacionPacienteOP">
            <ng-option value="">Seleccione...</ng-option>
            <ng-option value="05">CÉDULA</ng-option>
            <ng-option value="04">RUC</ng-option>
            <ng-option value="06">PASAPORTE</ng-option>
            <ng-option value="08">EXTERIOR</ng-option>
            <ng-option value="07">CONSUMIDOR FINAL</ng-option>
          </ng-select>
        </div>
        <div class="modal-field-group">
          <b>IDENTIFICACIÓN</b>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Identificación" [(ngModel)]='identificacionAdicional'>
            <button class="btn btn-light" (click)="buscarDataPersonasAdicional()"><i class="mdi mdi-account-search"></i></button>
          </div>
          @if (identificacionAdicional=='') {
            <p class="text-danger">Requerido</p>
          }
        </div>
        @if (spinnerBooleanBuscarDataAdicional) {
          <div class="text-center py-2">
            <div class="spinner-grow" role="status"><span class="sr-only">Loading...</span></div>
            <p class="mb-0 mt-1">Cargando...</p>
          </div>
        }
        <div class="form-row">
          <div class="col-6 modal-field-group">
            <b>NOMBRE</b>
            <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]='nombreAdicional'>
            @if (nombreAdicional=='') {
              <p class="text-danger">Requerido</p>
            }
          </div>
          <div class="col-6 modal-field-group">
            <b>DIRECCIÓN</b>
            <input type="text" class="form-control" placeholder="Dirección" [(ngModel)]='direccionAdicional'>
          </div>
        </div>
      </div>
    }

  </div>
  <div class="modal-footer">
    <button type="button" class="btn ripple btn-secondary" (click)="cerrarModal()">Cerrar</button>
    <button type="button" class="btn ripple btn-primary" (click)="guardarPaciente()" [attr.disabled]="guardarPac ? true : null">Guardar</button>
  </div>
</ng-template>

<!-- ----------------------------------------------------------------------- -->
<!--                          MODAL EDITAR PACIENTE                          -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #mdlEditarPaciente let-modal>
  <div class="modal-header">
    <h6 class="modal-title">ACTUALIZAR PACIENTE ({{nombrePaciente}})</h6>
    <button type="button" class="close" aria-label="Close" (click)="cerrarModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="text-center text-uppercase">


      <p class="text-center"><b>¿El paciente nos dió su número de identificación?</b></p>
      SI &nbsp; <input type="checkbox" [(ngModel)]="checkIdentificacionSI" (change)="cambiarSIIdent()" ><br>
      NO <input type="checkbox" [(ngModel)]="checkIdentificacionNO"  (change)="cambiarNOIdent()">

    </div>
    @if (spinnerBooleanBuscarData) {
      <div class="text-center">
        <hr>
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="text-center">Cargando por favor espere...</p>
          <br>
          </div>
        }


        <div class="form-row">
          @if (checkIdentificacionNO) {
            <div class="col-md-12" >
              <input type="text" class="form-control"  placeholder="Ingrese la identificacion" [(ngModel)]='randomCedula' value="{{randomCedula}}" readonly>
            </div>
          }
          <br>
            @if (checkIdentificacionSI) {
              <div class="col-md-6"  >
                <b>TIPO DE IDENTIFICACION</b>
                <div class="input-group">
                  <ng-select class="form-control" [(ngModel)]='nuevaIdentificacionPaciente'	placeholder="seleccione tipo de documento...">
                    <ng-option value="">Seleccione...</ng-option>
                    <ng-option value="05">CEDULA</ng-option>
                    <ng-option value="04">RUC</ng-option>
                    <ng-option value="06">PASAPORTE</ng-option>
                    <ng-option value="08">IDENTIFICACIÓN DELEXTERIOR</ng-option>
                  </ng-select>
                </div>
                @if (nuevaIdentificacionPaciente=='') {
                  <p class="text-danger" >Falta seleccionar tipo de identificación</p>
                }
              </div>
            }
            @if (checkIdentificacionSI) {
              <div class="col-md-6" >
                <b>IDENTIFICACIÓN</b>
                <div class="input-group">
                  <input type="text" class="form-control"  placeholder="Ingrese la identificacion"   [(ngModel)]='identificacionPaciente'>
                  <button class="btn btn-light"   (click)="buscarDataPersonas('editar')"><i class="mdi mdi-account-search" ></i></button>
                </div>
                @if (identificacionPaciente=='') {
                  <p class="text-danger" >Falta ingresar identificación</p>
                }
              </div>
            }


          </div>

          <br>
            <b>NOMBRE</b>
            <input type="text" class="form-control"  placeholder="Ingrese nombre"  [(ngModel)]='nombrePaciente'>
            @if (nombrePaciente=='') {
              <p class="text-danger" >Falta ingresar nombre paciente</p>
            }
            <br>
              <b>FECHA NACIMIENTO</b>
              <input type="date" class="form-control"  placeholder="Ingrese fechs nacimiento" (change)="cambiarFechaNacimiento()"  [(ngModel)]='fechaNacimientoPaciente'>
              @if (fechaNacimientoPaciente=='') {
                <p class="text-danger" >Falta seleccionar fecha nacimiento</p>
              }
              <br>
                <div class="text-center text-uppercase">


                  <p class="text-center"><b>¿El cliente nos dió el número de teléfono?</b></p>
                  SI &nbsp; <input type="checkbox"  [(ngModel)]="checkTelefonoSI" (change)="cambiarSITelef()"><br>
                  NO <input type="checkbox"   [(ngModel)]="checkTelefonoNO" (change)="cambiarNOTelf()">

                </div>
                <br>
                  @if (checkTelefonoSI) {
                    <div class="form-row">
                      <div class="col-md-6">
                        <b>PAÍS</b>
                        <ng-select class="form-control" id="seleccionarClienteInput" name="seleccionarClienteInput" [(ngModel)]='pais' (change)="cambiarPais()"
                          >
                          @for (obj of paisesList; track obj) {
                            <ng-option  [value]="obj.id+'|'+obj.codigo+'|'+obj.estructura">
                              <img src="{{obj.imagen}}" width="40px"> {{obj.nombre}}
                            </ng-option>
                          }
                        </ng-select>
                      </div>
                      <div class="col-md-6">
                        <b>TELÉFONO</b>
                        <input type="text" class="form-control"  placeholder="Ingrese el número de teléfono"  [(ngModel)]='nuevoTelefonoCliente'  mask="{{inputMaskPais}}">
                        @if (nuevoTelefonoCliente=='') {
                          <p class="text-danger" >Falta ingresar número teléfono</p>
                          }<br>
                        </div>
                      </div>
                    }
                    <div class="form-row">
                      <div class="col-md-6">
                        <b>EMAIL</b>
                        <input type="email" class="form-control"  placeholder="Ingrese el email" [(ngModel)]='nuevoEmailPaciente'>
                        @if (nuevoEmailPaciente=='') {
                          <p class="text-danger" >Falta ingresar email</p>
                        }

                      </div>

                      <div class="col-md-6">
                        <b>DIRECCIÓN</b>
                        <input type="text" class="form-control"  placeholder="Ingrese la dirección"  [(ngModel)]='direccionPaciente'>


                      </div>
                      <div class="col-md-6">
                        <br>
                          <b>SEXO</b>
                          <ng-select class="form-control" 	placeholder="seleccione el sexo..."  [(ngModel)]='sexoPaciente'>

                            <ng-option value="">Seleccione...</ng-option>
                            <ng-option value="masculino">MASCULINO</ng-option>
                            <ng-option value="femenino">FEMENINO</ng-option>
                            <ng-option value="persona-juridica">PERSONA JURIDICA</ng-option>
                            <ng-option value="otro">OTROS</ng-option>
                          </ng-select>
                          @if (sexoPaciente=='') {
                            <p class="text-danger" >Falta seleccionar sexo paciente</p>
                          }

                        </div>
                        <div class="col-md-6">
                          <br>
                            <b>EDAD</b>
                            <input type="number" class="form-control"  placeholder="Ingrese la edad" [(ngModel)]='nuevaEdadPaciente' readonly>

                          </div>
                        </div>
                        <br>
                          <b>¿Desea facturar a otra persona?</b> &nbsp; <input type="checkbox"  [(ngModel)]="checkFacturarOtrasPersonasSI"  (change)="cambiarFacturarOtraPersona()"><br>
                          <b>¿Desea facturar a consumidor final?</b> &nbsp; <input type="checkbox"  [(ngModel)]="checkConsumidorFinalNO"  (change)="cambiarConsumidorFinal()"><br>
                          <Hr>
                          @if (checkFacturarOtrasPersonasSI || checkConsumidorFinalNO) {
                            <div class="form-row">
                              <div class="col-md-12">
                                <b>TIPO DE IDENTIFICACION</b>
                                <div class="input-group">
                                  <ng-select class="form-control" 	placeholder="seleccione tipo de documento..."  [(ngModel)]="nuevaIdentificacionPacienteOP" >
                                    <ng-option value="">Seleccione...</ng-option>
                                    <ng-option value="05">CEDULA</ng-option>
                                    <ng-option value="04">RUC</ng-option>
                                    <ng-option value="06">PASAPORTE</ng-option>
                                    <ng-option value="08">IDENTIFICACIÓN DELEXTERIOR</ng-option>
                                    <ng-option value="07">VENTA A CONSUMIDOR FINAL</ng-option>
                                  </ng-select>
                                </div>
                                <br>
                                </div>
                                <div class="col-md-12">
                                  <b>IDENTIFICACION</b>
                                  <div class="input-group">
                                    <input type="text" class="form-control"  placeholder="Ingrese la identificacion"   [(ngModel)]='identificacionAdicional'>
                                    <button class="btn btn-light"   (click)="buscarDataPersonasAdicional()"><i class="mdi mdi-account-search" ></i></button>
                                  </div>
                                  @if (identificacionAdicional=='') {
                                    <p class="text-danger" >Falta ingresar identificación</p>
                                  }
                                </div>
                              </div>
                            }
                            <br>
                              @if (spinnerBooleanBuscarDataAdicional) {
                                <div class="text-center">
                                  <hr>
                                    <div class="spinner-grow" role="status">
                                      <span class="sr-only">Loading...</span>
                                    </div>
                                    <p class="text-center">Cargando por favor espere...</p>
                                    <br>
                                    </div>
                                  }

                                  @if (checkFacturarOtrasPersonasSI || checkConsumidorFinalNO) {
                                    <div class="form-row" >
                                      <div class="col-md-6">
                                        <b>NOMBRE</b>
                                        <input type="text" class="form-control"   placeholder="Ingrese nombre"   [(ngModel)]='nombreAdicional'    value="{{nombreAdicional}}">
                                        @if (nombreAdicional=='') {
                                          <p class="text-danger" >Falta ingresar nombre</p>
                                        }
                                      </div>
                                      <div class="col-md-6">
                                        <b>DIRECCIÓN</b>
                                        <input type="text" class="form-control"  placeholder="Ingrese dirección"    [(ngModel)]='direccionAdicional' value="{{direccionAdicional}}">
                                        @if (direccionAdicional=='') {
                                          <p class="text-danger" >Falta ingresar dirección</p>
                                        }
                                      </div>
                                    </div>
                                  }



                                </div>
                                <div class="modal-footer">
                                  <button type="button" class="btn ripple btn-primary" (click)="editarPaciente()"  [attr.disabled]="guardarPac ? true : null">Guardar</button>
                                  <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModal()">Cerrar</button>
                                </div>
                              </ng-template>



                              <!-- ----------------------------------------------------------------------- -->
                              <!--                          MODAL AGREGAR DOCTOR                           -->
                              <!-- ----------------------------------------------------------------------- -->
                              <ng-template #mdlAgregarDoctor let-modal>
                                <div class="modal-header">
                                  <h6 class="modal-title">INGRESAR NUEVO DOCTOR</h6>
                                  <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">


                                  @if (spinnerBooleanBuscarData) {
                                    <div class="text-center">
                                      <hr>
                                        <div class="spinner-grow" role="status">
                                          <span class="sr-only">Loading...</span>
                                        </div>
                                        <p class="text-center">Cargando por favor espere...</p>
                                      </div>
                                    }


                                    <div class="form-row">

                                      <div class="col-md-6"  >
                                        <b>TIPO DE IDENTIFICACION</b>
                                        <div class="input-group">

                                          <ng-select class="form-control" [(ngModel)]='nuevaIdentificacionDoctor'	placeholder="seleccione tipo de documento...">

                                            <ng-option value="">Seleccione...</ng-option>
                                            <ng-option value="05">CEDULA</ng-option>
                                            <ng-option value="04">RUC</ng-option>
                                            <ng-option value="06">PASAPORTE</ng-option>
                                            <ng-option value="08">IDENTIFICACIÓN DEL EXTERIOR</ng-option>


                                          </ng-select>

                                        </div>
                                        @if (nuevaIdentificacionDoctor=='') {
                                          <p class="text-danger" >Falta seleccionar tipo de identificación</p>
                                        }

                                      </div>
                                      <div class="col-md-6" >
                                        <b>IDENTIFICACIÓN</b>
                                        <div class="input-group">

                                          <input type="text" class="form-control"  placeholder="Ingrese la identificacion"  [(ngModel)]='identificacionDoctor'>

                                          <button class="btn btn-light"   (click)="buscarDataPersonasDoctor('agregar')"><i class="mdi mdi-account-search" ></i></button>

                                        </div>

                                        @if (identificacionDoctor=='') {
                                          <p class="text-danger" >Falta ingresar identificación</p>
                                        }

                                      </div>


                                    </div>
                                    <br>
                                      <div class="form-row">

                                        <div class="col-md-6">
                                          <b>NOMBRE</b>
                                          <input type="text" class="form-control"  placeholder="Ingrese nombre"  [(ngModel)]='nuevoNombreDoctor'>
                                          @if (nuevoNombreDoctor=='') {
                                            <p class="text-danger" >Falta ingresar nombre paciente</p>
                                          }
                                          <br>

                                          </div>
                                          <div class="col-md-6">
                                            <b>FECHA NACIMIENTO</b>
                                            <input type="date" class="form-control"  placeholder="Ingrese fechs nacimiento" (change)="cambiarFechaNacimientoDoctor()"  [(ngModel)]='nuevaFechaNDoctor'>
                                            @if (nuevaFechaNDoctor=='') {
                                              <p class="text-danger" >Falta seleccionar fecha nacimiento</p>
                                            }
                                            <br>
                                            </div>
                                          </div>

                                          <div class="form-row">
                                            <div class="col-md-6">
                                              <b>TELÉFONO</b>
                                              <input type="text" class="form-control"  placeholder="Ingrese el número de teléfono"  [(ngModel)]='nuevoTelefonoDoctor'  mask="000 000 0000">
                                              @if (nuevoTelefonoDoctor=='') {
                                                <p class="text-danger" >Falta ingresar número teléfono</p>
                                                }<br>

                                              </div>
                                              <div class="col-md-6">
                                                <b>EMAIL</b>
                                                <input type="email" class="form-control"  placeholder="Ingrese el email" [(ngModel)]='nuevoEmailDoctor'>
                                                @if (nuevoEmailDoctor=='') {
                                                  <p class="text-danger" >Falta ingresar email</p>
                                                }

                                              </div>
                                            </div>
                                            <div class="form-row">

                                              <div class="col-md-6">
                                                <b>DIRECCIÓN</b>
                                                <input type="text" class="form-control"  placeholder="Ingrese la dirección"  [(ngModel)]='nuevaDireccionDoctor'>
                                                @if (nuevaDireccionDoctor=='') {
                                                  <p class="text-danger" >Falta ingresar dirección</p>
                                                }

                                              </div>
                                              <div class="col-md-6">

                                                <b>EDAD</b>
                                                <input type="number" class="form-control"  placeholder="Ingrese la edad"  [(ngModel)]='nuevaEdadDoctor' readonly>

                                              </div>

                                            </div>
                                            <br>
                                              <div class="form-row">


                                                <div class="col-md-6">
                                                  <b>BANCO</b>
                                                  <input type="text" class="form-control"   placeholder="Ingrese nombre"    [(ngModel)]='bancoDoctor'   disabled>
                                                  @if (bancoDoctor=='') {
                                                    <p class="text-danger" >Falta ingresar nombre</p>
                                                  }

                                                </div>
                                                <div class="col-md-6">
                                                  <b>N. CUENTA</b>
                                                  <input type="text" class="form-control"  placeholder="Ingrese numero cuenta"    [(ngModel)]='cuentaDoctor' disabled>
                                                  @if (cuentaDoctor=='') {
                                                    <p class="text-danger" >Falta ingresar dirección</p>
                                                  }

                                                </div>
                                              </div>
                                              <br>
                                                <div class="form-row">


                                                  <div class="col-md-6">
                                                    <b>TALONARIO</b>
                                                    <input type="text" class="form-control"  placeholder="Ingrese talonario"    [(ngModel)]='talonarioDocotor' disabled>
                                                    @if (talonarioDocotor=='') {
                                                      <p class="text-danger" >Falta ingresar talonario</p>
                                                    }

                                                  </div>
                                                  <div class="col-md-6">

                                                    <b>ESPECIALIDAD</b>
                                                    <ng-select class="form-control" 	placeholder="seleccione especialidad..."  [(ngModel)]='especialidaDoctor'>
                                                      <ng-option value="">Seleccione...</ng-option>
                                                      @for (obj of especialidadesList; track obj) {
                                                        <ng-option  [value]="obj.datos">
                                                          {{obj.datos}}
                                                        </ng-option>
                                                      }
                                                    </ng-select>
                                                    @if (especialidaDoctor=='') {
                                                      <p class="text-danger" >Falta seleccionar una especialidad</p>
                                                    }

                                                  </div>
                                                </div>
                                                <br>






                                                </div>
                                                <div class="modal-footer">
                                                  <button type="button" class="btn ripple btn-primary" (click)="guardarDoctor()" [attr.disabled]="guardarPac ? true : null">Guardar</button>
                                                  <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                </div>
                                              </ng-template>


                                              <!-- ----------------------------------------------------------------------- -->
                                              <!--                     MODAL SOLICITAR ORDENES FISICAS                     -->
                                              <!-- ----------------------------------------------------------------------- -->
                                              <ng-template #mdlAsginarSecuenciaFisica let-modal>
                                                <div class="modal-header">
                                                  <h6 class="modal-title">ASIGNAR SECUENCIA FISICA ({{nombreDoctor}})</h6>
                                                  <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                    <span aria-hidden="true">&times;</span>
                                                  </button>
                                                </div>
                                                <div class="modal-body">


                                                  @if (spinnerBooleanBuscarData) {
                                                    <div class="text-center">
                                                      <hr>
                                                        <div class="spinner-grow" role="status">
                                                          <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <p class="text-center">Cargando por favor espere...</p>
                                                      </div>
                                                    }




                                                    <div class="form-row">
                                                      <div class="col-md-12">
                                                        <b>INGRESE  COMENTARIO</b>
                                                        <input type="text" class="form-control"    [(ngModel)]='nuevaDescripcionSolicitdOF'>
                                                        <p class="text-success" >Campo opcional.</p><br>

                                                      </div>

                                                    </div>






                                                  </div>
                                                  <div class="modal-footer">
                                                    <button type="button" class="btn ripple btn-primary" (click)="guardarSolicitudOF()">Guardar</button>
                                                    <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                  </div>
                                                </ng-template>



                                                <!-- ----------------------------------------------------------------------- -->
                                                <!--                         SOLICITAR CAPACITACIÓN                          -->
                                                <!-- ----------------------------------------------------------------------- -->
                                                <ng-template #mdlSolicitarCapacitacion let-modal>
                                                  <div class="modal-header">
                                                    <h6 class="modal-title">CAPACITACIÓN ({{nombreDoctor}})</h6>
                                                    <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                      <span aria-hidden="true">&times;</span>
                                                    </button>
                                                  </div>
                                                  <div class="modal-body">


                                                    @if (spinnerBooleanBuscarData) {
                                                      <div class="text-center">
                                                        <hr>
                                                          <div class="spinner-grow" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                          </div>
                                                          <p class="text-center">Cargando por favor espere...</p>
                                                        </div>
                                                      }




                                                      <div class="form-row">
                                                        <div class="col-md-12">
                                                          <b>FECHA A CAPACITAR</b>
                                                          <input type="date" class="form-control"    [(ngModel)]='nuevaFechaCapacitar'>


                                                        </div>

                                                      </div>
                                                      <br>
                                                        <div class="form-row">
                                                          <div class="col-md-12">
                                                            <b>INGRESE UN COMENTARIO</b>
                                                            <input type="text" class="form-control"    [(ngModel)]='nuevoComentarioCapacitar'>


                                                          </div>

                                                        </div>
                                                        <br>
                                                          <div class="form-row">
                                                            <div class="col-md-12">
                                                              <b>TIPO CAPACITACIÓN</b><br>
                                                              <input type="checkbox"  [(ngModel)]='checkTomografia' (change)="cambiaItem1('Tomografía')"> Tomografía<br>
                                                              <input type="checkbox"  [(ngModel)]='dosD' (change)="cambiaItem2('2D')"> 2D<br>
                                                              <input type="checkbox"  [(ngModel)]='app' (change)="cambiaItem3('App')"> App<br>


                                                            </div>

                                                          </div>






                                                        </div>
                                                        <div class="modal-footer">
                                                          <button type="button" class="btn ripple btn-primary" (click)="guardarSolicitudCap()" [attr.disabled]="guardarPac ? true : null">Guardar</button>
                                                          <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                        </div>
                                                      </ng-template>


                                                      <!-- ----------------------------------------------------------------------- -->
                                                      <!--                             BUSCAR SERVICIO                             -->
                                                      <!-- ----------------------------------------------------------------------- -->
                                                      <ng-template #mdlBuscarServicios let-modal>
                                                        <div class="modal-header">
                                                          <h6 class="modal-title">SERVICIOS {{tipo}}</h6>
                                                          <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                            <span aria-hidden="true">&times;</span>
                                                          </button>
                                                        </div>
                                                        <div class="modal-body">


                                                          @if (spinnerBoolean) {
                                                            <div class="text-center">
                                                              <hr>
                                                                <div class="spinner-grow" role="status">
                                                                  <span class="sr-only">Loading...</span>
                                                                </div>
                                                                <p class="text-center">Cargando por favor espere...</p>
                                                              </div>
                                                            }
                                                            <b>Buscar</b>
                                                            @if (tipo=='TOMOGRAFIA 3D (MATRIZ)' || tipo=='TOMOGRAFIA 3D') {
                                                              <div class="tomografia-dims">
                                                                <label><input type="checkbox" [(ngModel)]='dime5' (change)="buscarDimensiones5()" value="210*160"> 210*160</label>
                                                                <label><input type="checkbox" [(ngModel)]='dime6' (change)="buscarDimensiones6()" value="150*160"> 150*160</label>
                                                                <label><input type="checkbox" [(ngModel)]='dime1' (change)="buscarDimensiones1()" value="100*80"> 100*80</label>
                                                                <label><input type="checkbox" [(ngModel)]='dime2' (change)="buscarDimensiones2()" value="100*40"> 100*40</label>
                                                                <label><input type="checkbox" [(ngModel)]='dime3' (change)="buscarDimensiones3()" value="40*80"> 40*80</label>
                                                                <label><input type="checkbox" [(ngModel)]='dime4' (change)="buscarDimensiones4()" value="40*40"> 40*40</label>
                                                              </div>
                                                            }
                                                            @if (tipo=='LABORATORIO' || tipo=='LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)') {
                                                              <div  >
                                                                @for (obj of listaPerfiles; track obj) {
                                                                  <div  >
                                                                    <input type="checkbox"  (change)="buscarPerfil($event, obj.codigo)" > &nbsp;&nbsp;{{obj.perfil}}
                                                                  </div>
                                                                }
                                                              </div>
                                                            }
                                                            <br>
                                                              <input type="text" class="form-control"  (keydown)="updateFilter($event)"  [(ngModel)]='buscarServicio' placeholder="Buscar">
                                                              <div class="table-responsive">
                                                                <ngx-datatable #table class='bootstrap'   style="height: 700px;" [rows]="serviciolist"  columnMode="force"  [headerHeight]="30" [footerHeight]="30"
                                                                  rowHeight="auto"[externalPaging]="true" [limit]="size" [count]="totalElements"
                                                                  [offset]="pageNumber" (page)="setPage($event)"
                                                                  >

                                                                  <ngx-datatable-column name="IMAGEN" prop='IMG_PRO'>
                                                                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                                                      let-row="row" >
                                                                      @if (serviciolist[rowIndex].IMG_PRO != "") {
                                                                        <div><img class="img-thumbnail" width="40px" src="https://sistema.cmsalud.ec/radiografia/{{serviciolist[rowIndex].IMG_PRO}}">  </div>
                                                                      }
                                                                      @if (serviciolist[rowIndex].IMG_PRO == "") {
                                                                        <div><img class="img-thumbnail" width="40px"src="./assets/img/brand/logocm.png">  </div>
                                                                      }

                                                                    </ng-template>

                                                                  </ngx-datatable-column>

                                                                  <ngx-datatable-column name="NOMBRE" prop='NOM_PRO'>
                                                                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                                                      let-row="row">
                                                                      @if (serviciolist[rowIndex].INFO_PRO == null || serviciolist[rowIndex].INFO_PRO == 'null' || serviciolist[rowIndex].INFO_PRO =='') {
                                                                        <div>{{serviciolist[rowIndex].NOM_PRO}} </div>
                                                                      }
                                                                      @if (serviciolist[rowIndex].INFO_PRO != null && serviciolist[rowIndex].INFO_PRO != 'null' && serviciolist[rowIndex].INFO_PRO !='') {
                                                                        <div><a href="javascript:;" (click)="mostrarModalInformacion( mdlModalInformacionPrueba,serviciolist[rowIndex].INFO_PRO)">{{serviciolist[rowIndex].NOM_PRO}} </a></div>
                                                                      }

                                                                    </ng-template>
                                                                  </ngx-datatable-column>


                                                                  <ngx-datatable-column name="VALOR" prop='VAL_PRO'>
                                                                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                                                      let-row="row">

                                                                      <div>{{precioItem(serviciolist[rowIndex].CODN_PRO,  serviciolist[rowIndex].VAL_PRO, serviciolist[rowIndex].VAL2_PRO, serviciolist[rowIndex].VAL3_PRO, serviciolist[rowIndex].VAL4_PRO, serviciolist[rowIndex].DER_PRO, serviciolist[rowIndex].TIP_PRO, serviciolist[rowIndex].preciosLab, serviciolist[rowIndex].VALEMP_PRO).split(",")[0]}}</div>

                                                                    </ng-template>
                                                                  </ngx-datatable-column>



                                                                  <ngx-datatable-column name="ACCIONES">
                                                                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                                                      let-row="row">
                                                                      @if (serviciolist[rowIndex].TIP_PRO != 'PERFILES'  && serviciolist[rowIndex].CODN_PRO != 'LATE 001' && serviciolist[rowIndex].TIP_PRO != 'RADIOGRAFIAS CORPORAL') {
                                                                        <button class="btn btn-primary"   (click)="abrirModalPiezas(mdlAgregarPiezas,modalListaAnalisis, serviciolist[rowIndex].CODN_PRO, serviciolist[rowIndex].NOM_PRO, serviciolist[rowIndex].COD_PRO, serviciolist[rowIndex].TIP_PRO,precioItem(serviciolist[rowIndex].CODN_PRO,  serviciolist[rowIndex].VAL_PRO, serviciolist[rowIndex].VAL2_PRO, serviciolist[rowIndex].VAL3_PRO, serviciolist[rowIndex].VAL4_PRO, serviciolist[rowIndex].DER_PRO, serviciolist[rowIndex].TIP_PRO, serviciolist[rowIndex].preciosLab, serviciolist[rowIndex].VALEMP_PRO), serviciolist[rowIndex].IMP_PRO, serviciolist[rowIndex].INCLIVA_PRO,serviciolist[rowIndex].JSON_ANALISIS)">Agregar</button>
                                                                      }
                                                                      @if (serviciolist[rowIndex].TIP_PRO == 'PERFILES' || serviciolist[rowIndex].CODN_PRO == 'LATE 001') {
                                                                        <button class="btn btn-primary"   (click)="buscarSubServicios(serviciolist[rowIndex].COD_PRO)">Agregar</button>
                                                                      }
                                                                      @if (serviciolist[rowIndex].TIP_PRO === 'RADIOGRAFIAS CORPORAL') {
                                                                        <button class="btn btn-primary"   (click)="buarRadiografiaCorporal(serviciolist[rowIndex].COD_PRO, modalSubserviciosCorporal, serviciolist[rowIndex].SUB_SERVICES)">Agregar</button>
                                                                      }

                                                                    </ng-template>
                                                                  </ngx-datatable-column>

                                                                </ngx-datatable>
                                                              </div>






                                                            </div>
                                                            <div class="modal-footer">

                                                              <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                            </div>
                                                          </ng-template>



                                                          <!-- ----------------------------------------------------------------------- -->
                                                          <!--                        AGREGAR NUMEROS DE PIEZAS                        -->
                                                          <!-- ----------------------------------------------------------------------- -->
                                                          <ng-template #mdlAgregarPiezas let-modal>
                                                            <div class="modal-header">
                                                              <h6 class="modal-title">SELECCIONE LOS NUMERO DE PIEZAS ({{servicioEscodigo}})</h6>
                                                              <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                                <span aria-hidden="true">&times;</span>
                                                              </button>
                                                            </div>
                                                            <div class="modal-body">

                                                              <!-- Opciones especiales (comunes desktop+móvil) -->
                                                              <div class="odonto-extra-checks">
                                                                @if (checkMConductometria) {
                                                                  <label><input type="checkbox" [(ngModel)]='checkConductometria' (change)="cbxConductometria();"> Conductometría</label>
                                                                }
                                                                @if (checkMIzquierda) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkIzquierda' (change)="cbxIzquierda();"> Izquierda</label>
                                                                }
                                                                @if (checkMDerecha) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkDerecha' (change)="cbxDerecha();"> Derecha</label>
                                                                }
                                                                @if (checkMAbierto) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkAbierto' (change)="cbxAbierto();"> Abierto</label>
                                                                }
                                                                @if (checkMCerrado) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkCerrado' (change)="cbxCerrado();"> Cerrado</label>
                                                                }
                                                                @if (checkMSuperior) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkSuperior' (change)="cbxSuperior();"> Superior</label>
                                                                }
                                                                @if (checkMInferior) {
                                                                  <label><input type="checkbox"  [(ngModel)]='checkInferior' (change)="cbxInferior();"> Inferior</label>
                                                                }
                                                              </div>

                                                              <!-- ── Versión móvil: chips por cuadrante ─────────────────────────── -->
                                                              <div class="d-md-none odonto-mobile">
                                                                <!-- Superior -->
                                                                <div class="odonto-half-wrap">
                                                                  <div class="odonto-quadrant">
                                                                    <div class="odonto-q-label">Superior Der.</div>
                                                                    <div class="odonto-chips">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="18"><span>18</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="17"><span>17</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="16"><span>16</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="15"><span>15</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="14"><span>14</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="13"><span>13</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="12"><span>12</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="11"><span>11</span></label>
                                                                    </div>
                                                                    <div class="odonto-chips odonto-chips--child">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="55"><span>55</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="54"><span>54</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="53"><span>53</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="52"><span>52</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="51"><span>51</span></label>
                                                                    </div>
                                                                  </div>
                                                                  <div class="odonto-center-line"></div>
                                                                  <div class="odonto-quadrant">
                                                                    <div class="odonto-q-label">Superior Izq.</div>
                                                                    <div class="odonto-chips">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="21"><span>21</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="22"><span>22</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="23"><span>23</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="24"><span>24</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="25"><span>25</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="26"><span>26</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="27"><span>27</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="28"><span>28</span></label>
                                                                    </div>
                                                                    <div class="odonto-chips odonto-chips--child">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="61"><span>61</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="62"><span>62</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="63"><span>63</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="64"><span>64</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="65"><span>65</span></label>
                                                                    </div>
                                                                  </div>
                                                                </div>

                                                                <div class="odonto-divider"></div>

                                                                <!-- Inferior -->
                                                                <div class="odonto-half-wrap">
                                                                  <div class="odonto-quadrant">
                                                                    <div class="odonto-chips odonto-chips--child">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="85"><span>85</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="84"><span>84</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="83"><span>83</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="82"><span>82</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="81"><span>81</span></label>
                                                                    </div>
                                                                    <div class="odonto-chips">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="48"><span>48</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="47"><span>47</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="46"><span>46</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="45"><span>45</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="44"><span>44</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="43"><span>43</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="42"><span>42</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="41"><span>41</span></label>
                                                                    </div>
                                                                    <div class="odonto-q-label odonto-q-label--bottom">Inferior Der.</div>
                                                                  </div>
                                                                  <div class="odonto-center-line"></div>
                                                                  <div class="odonto-quadrant">
                                                                    <div class="odonto-chips odonto-chips--child">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="71"><span>71</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="72"><span>72</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="73"><span>73</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="74"><span>74</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="75"><span>75</span></label>
                                                                    </div>
                                                                    <div class="odonto-chips">
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="31"><span>31</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="32"><span>32</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="33"><span>33</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="34"><span>34</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="35"><span>35</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="36"><span>36</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="37"><span>37</span></label>
                                                                      <label class="odonto-chip"><input type="checkbox" (change)="getNumeroPiezas($event)" value="38"><span>38</span></label>
                                                                    </div>
                                                                    <div class="odonto-q-label odonto-q-label--bottom">Inferior Izq.</div>
                                                                  </div>
                                                                </div>
                                                              </div>

                                                              <!-- ── Versión desktop: tabla clásica ────────────────────────────── -->
                                                              <div class="d-none d-md-block">
                                                                <table class="table table-bordered table-striped dt-responsive" id="contenedorOdontograma">
                                                                  <tr>

                                                                    <td >

                                                                      <img src="./assets/img/brand/diente.png"  class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="18" class="text-center">&nbsp;18


                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="17" class="text-center">&nbsp;17
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="16" class="text-center">&nbsp;16
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="15" class="text-center">&nbsp;15
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="14" class="text-center">&nbsp;14
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="13" class="text-center">&nbsp;13
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="12" class="text-center">&nbsp;12
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="11" class="text-center">&nbsp;11
                                                                    </td>
                                                                    <td style="width:10px;background-color: #F2F3F4;"></td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="21" class="text-center">&nbsp;21
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="22" class="text-center">&nbsp;22
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="23" class="text-center">&nbsp;23
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="24" class="text-center">&nbsp;24
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="25" class="text-center">&nbsp;25
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="26" class="text-center">&nbsp;26
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="27" class="text-center">&nbsp;27
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="28" class="text-center">&nbsp;28
                                                                    </td>

                                                                  </tr>
                                                                  <tr>


                                                                    <td>

                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="55" class="text-center">&nbsp;55
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="54" class="text-center">&nbsp;54
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="53" class="text-center">&nbsp;53
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="52" class="text-center">&nbsp;52
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="51" class="text-center">&nbsp;51
                                                                    </td>
                                                                    <td style="width:10px; background-color: #F2F3F4;"></td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="61" class="text-center">&nbsp;61
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="62" class="text-center">&nbsp;62
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="63" class="text-center">&nbsp;63
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="64" class="text-center">&nbsp;64
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="65"  class="text-center">&nbsp;65
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>

                                                                  </tr>
                                                                  <tr>


                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="85" class="text-center">&nbsp;85
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="84" class="text-center">&nbsp;84
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="83" class="text-center">&nbsp;83
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="82" class="text-center">&nbsp;82
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="81" class="text-center">&nbsp;81
                                                                    </td>
                                                                    <td style="width:10px; background-color: #F2F3F4;"></td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="71" class="text-center">&nbsp;71
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="72" class="text-center">&nbsp;72
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="73" class="text-center">&nbsp;73
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="74" class="text-center">&nbsp;74
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="75" class="text-center">&nbsp;75
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>
                                                                    <td>
                                                                      <p class="text-center"></p>
                                                                    </td>

                                                                  </tr>
                                                                  <tr>

                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="48" class="text-center">&nbsp;48
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="47" class="text-center">&nbsp;47
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="46" class="text-center">&nbsp;46
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="45" class="text-center">&nbsp;45
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="44" class="text-center">&nbsp;44
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="43" class="text-center">&nbsp;43
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="42" class="text-center">&nbsp;42
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="41" class="text-center">&nbsp;41
                                                                    </td>
                                                                    <td style="width:10px;background-color: #F2F3F4;"></td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="31" class="text-center">&nbsp;31
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="32" class="text-center">&nbsp;32
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="33" class="text-center">&nbsp;33
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="34" class="text-center">&nbsp;34
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="35" class="text-center">&nbsp;35
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="36" class="text-center">&nbsp;36
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="37" class="text-center">&nbsp;37
                                                                    </td>
                                                                    <td>
                                                                      <img src="./assets/img/brand/diente.png" class="text-center" width="60px">
                                                                      &nbsp;&nbsp;<input type="checkbox" (change)="getNumeroPiezas($event)" value="38" class="text-center">&nbsp;38
                                                                    </td>

                                                                  </tr>
                                                                </table>
                                                              </div><!-- /d-none d-md-block -->

                                                            </div>
                                                            <div class="modal-footer">

                                                              <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalOdontograma()">Cerrar</button>
                                                              <button type="button" class="btn ripple btn-success" (click)="agregarDetalleMDOdont()" >Aceptar</button>
                                                            </div>
                                                          </ng-template>


                                                          <!-- ----------------------------------------------------------------------- -->
                                                          <!--                       SOLICITUD CAMBIO DE PRECIO                        -->
                                                          <!-- ----------------------------------------------------------------------- -->
                                                          <ng-template #mdlSolicitarCambio let-modal>
                                                            <div class="modal-header">
                                                              <h6 class="modal-title">SOLICITUD CAMBIO DE PRECIO</h6>
                                                              <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                                <span aria-hidden="true">&times;</span>
                                                              </button>
                                                            </div>
                                                            <div class="modal-body">


                                                              @if (spinnerBoolean) {
                                                                <div class="text-center">
                                                                  <hr>
                                                                    <div class="spinner-grow" role="status">
                                                                      <span class="sr-only">Loading...</span>
                                                                    </div>
                                                                    <p class="text-center">Cargando por favor espere...</p>
                                                                  </div>
                                                                }
                                                                <b>SERVICIO</b>
                                                                <p>{{productoSeleccionadoCP}}</p>
                                                                @if (!(cbxPrecioSugerido || cbxCuponDescuento)) {
                                                                  <b >PRECIOS DISPONIBLES</b>
                                                                }
                                                                @if (!(cbxPrecioSugerido || cbxCuponDescuento)) {
                                                                  <ng-select class="form-control"
                                                                    placeholder="Seleccione un precio" style="width: 100%;" [(ngModel)]='txtPreciosDisponibles'>
                                                                    @for (obj of preciosCambioList; track obj) {
                                                                      <ng-option [value]="obj.valor">
                                                                        {{obj.item}}
                                                                      </ng-option>
                                                                    }
                                                                  </ng-select>
                                                                }
                                                                <br>

                                                                  <b>{{precioSugerido}}</b>&nbsp;<input type="checkbox"  [(ngModel)]='cbxPrecioSugerido'  (change)="changePrecios($event)">
                                                                  @if (cbxPrecioSugerido && !cbxCuponDescuento) {
                                                                    <div>
                                                                      <input type="number" class="form-control"  [(ngModel)]='txtPrecioSugerido' placeholder="Ingrese el precio sugerido" >
                                                                    </div>
                                                                  }


                                                                  <b >CUPON DESCUENTO</b>&nbsp;<input type="checkbox"  [(ngModel)]='cbxCuponDescuento'  (change)="cbxchangePreciosCupon($event)">
                                                                  <br>
                                                                    @if (cbxCuponDescuento && !cbxPrecioSugerido) {
                                                                      <div>
                                                                        <input type="text" class="form-control"  [(ngModel)]='txtCuponDescuento' placeholder="Ingrese el cupón de descuento" >
                                                                      </div>
                                                                    }

                                                                    @if (contenedorValidarPrecio) {
                                                                      <div class="col-lg-12 col-xl-6 col-xxl-12 col-md-12 col-12">
                                                                        <hr>
                                                                          <div class="card custom-card">
                                                                            <div class="card-body pb-3">
                                                                                                                                                            @if (solicitudPrecioResultado) {
                                                                                <div class="price-request-result" [class.price-request-result--approved]="solicitudPrecioResultado.aprobado" [class.price-request-result--rejected]="!solicitudPrecioResultado.aprobado">
                                                                                  <div class="price-request-result__icon">
                                                                                    <i class="fa" [class.fa-check]="solicitudPrecioResultado.aprobado" [class.fa-times]="!solicitudPrecioResultado.aprobado"></i>
                                                                                  </div>
                                                                                  <div class="price-request-result__content">
                                                                                    <span class="price-request-result__eyebrow">
                                                                                      {{ solicitudPrecioResultado.numeroSolicitud || 'Solicitud procesada' }}
                                                                                    </span>
                                                                                    <h6>
                                                                                      {{ solicitudPrecioResultado.aprobado ? 'Solicitud aceptada' : 'Solicitud rechazada' }}
                                                                                    </h6>
                                                                                    <p>
                                                                                      {{ solicitudPrecioResultado.aprobado ? 'Administración aprobó el cambio de precio. El código se colocó automáticamente; presione validar para aplicar el precio.' : 'Administración rechazó el cambio de precio. No se generó código de confirmación.' }}
                                                                                    </p>
                                                                                  </div>
                                                                                </div>
                                                                              }
                                                                                                    @if (solicitudPrecioResultado) {
                                                                                                      <div class="price-request-result" [class.price-request-result--approved]="solicitudPrecioResultado.aprobado" [class.price-request-result--rejected]="!solicitudPrecioResultado.aprobado">
                                                                                                        <div class="price-request-result__icon">
                                                                                                          <i class="fa" [class.fa-check]="solicitudPrecioResultado.aprobado" [class.fa-times]="!solicitudPrecioResultado.aprobado"></i>
                                                                                                        </div>
                                                                                                        <div class="price-request-result__content">
                                                                                                          <span class="price-request-result__eyebrow">
                                                                                                            {{ solicitudPrecioResultado.numeroSolicitud || 'Solicitud procesada' }}
                                                                                                          </span>
                                                                                                          <h6>
                                                                                                            {{ solicitudPrecioResultado.aprobado ? 'Solicitud aceptada' : 'Solicitud rechazada' }}
                                                                                                          </h6>
                                                                                                          <p>
                                                                                                            {{ solicitudPrecioResultado.aprobado ? 'Administración aprobó el descuento. El código se colocó automáticamente; presione validar para aplicar el descuento.' : 'Administración rechazó el descuento. No se generó código de confirmación.' }}
                                                                                                          </p>
                                                                                                        </div>
                                                                                                      </div>
                                                                                                    }
<p  class="mb-2 tx-12"><b>INGRESE EL CÓDIGO DE VERIFICACIÓN:</b> <input class="form-control" [(ngModel)]='codigoFacturadorValidacion'  type="number"></p>
                                                                              <button class="btn btn-success" [disabled]="solicitudPrecioResultado && !solicitudPrecioResultado.aprobado" (click)="validarCodigo()">VALIDAR</button>
                                                                              <button class="btn btn-outline-primary ms-2" type="button" [disabled]="cargandoCodigosAprobados" (click)="actualizarCodigosAprobadosHoy()">
                                                                                <i class="fa fa-refresh"></i> Actualizar códigos
                                                                              </button>
                                                                              <div class="mt-3">
                                                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                                                  <b class="tx-12">CÓDIGOS APROBADOS HOY</b>
                                                                                  @if (cargandoCodigosAprobados) {
                                                                                    <small class="text-muted">Actualizando...</small>
                                                                                  }
                                                                                </div>
                                                                                @if (codigosAprobadosHoy.length === 0) {
                                                                                  <small class="text-muted">Sin códigos aprobados para hoy.</small>
                                                                                }
                                                                                @if (codigosAprobadosHoy.length > 0) {
                                                                                  <div class="table-responsive">
                                                                                    <table class="table table-sm table-bordered mb-0">
                                                                                      <tbody>
                                                                                        @for (codigo of codigosAprobadosHoy; track codigo.id) {
                                                                                          <tr>
                                                                                            <td>
                                                                                              <b>{{ codigo.codigo }}</b><br>
                                                                                              <small>{{ codigo.numeroSolicitud }} - {{ codigo.servicio }}</small>
                                                                                              <br>
                                                                                              <small class="text-muted">Solicitud: {{ codigo.fecha | date:'dd/MM/yyyy HH:mm' }}</small>
                                                                                            </td>
                                                                                            <td class="text-end">
                                                                                              <button type="button" class="btn btn-sm btn-outline-success" (click)="usarCodigoAprobado(codigo.codigo)">Usar</button>
                                                                                            </td>
                                                                                          </tr>
                                                                                        }
                                                                                      </tbody>
                                                                                    </table>
                                                                                  </div>
                                                                                }
                                                                              </div>
                                                                              <br>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        }







                                                                      </div>
                                                                      <div class="modal-footer">

                                                                        <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                                        <button type="button" class="btn ripple btn-primary"  (click)="solicitarCambio()">SOLICITAR</button>
                                                                      </div>
                                                                    </ng-template>



                                                                    <!-- ----------------------------------------------------------------------- -->
                                                                    <!--                       SOLICITUD CAMBIO DE PRECIO                        -->
                                                                    <!-- ----------------------------------------------------------------------- -->
                                                                    <ng-template #mdlAbrirModalGuardar let-modal>
                                                                      <div class="modal-header">
                                                                        <h6 class="modal-title">GUARDAR TRANSACCIÓN</h6>

                                                                      </div>
                                                                      <div class="modal-body">


                                                                        @if (spinnerBoolean) {
                                                                          <div class="text-center">
                                                                            <hr>
                                                                              <div class="spinner-grow" role="status">
                                                                                <span class="sr-only">Loading...</span>
                                                                              </div>
                                                                              <p class="text-center">{{cargando}}</p>
                                                                            </div>
                                                                          }
                                                                          <div class="col-lg-6 col-xl-6 col-xxl-12 col-md-12 col-12">
                                                                            <hr>
                                                                              <div class="card custom-card">
                                                                                <div class="card-body pb-3">

                                                                                  <p class="text-center"><b>TOTAL DE LA TRANSACCIÓN</b></p>
                                                                                  <h1 class="text-center">$ {{total}}</h1>

                                                                                  <br>
                                                                                  </div>
                                                                                </div>
                                                                              </div>



                                                                              <b>DINERO RICIBIDO DEL CLIENTE</b>&nbsp;<input type="text"  [(ngModel)]='dineroRecibido'  (input)="dineroRecibirCliente($event)" class="form-control" placeholder="Ingrese dinero recibido" type="number">
                                                                              <br>

                                                                                @if (dineroEnt<0) {
                                                                                  <div>
                                                                                    <b>DINERO A ENTREGAR</b>&nbsp;<input type="text"  [(ngModel)]='dineroEntregar'  class="form-control text-danger" disabled>
                                                                                  </div>
                                                                                }

                                                                                @if (dineroEnt>=0) {
                                                                                  <div>
                                                                                    <b>DINERO A ENTREGAR</b>&nbsp;<input type="text"  [(ngModel)]='dineroEntregar'  class="form-control text-success" disabled>
                                                                                  </div>
                                                                                }

                                                                                <br>
                                                                                  @if (esTarjeta) {
                                                                                    <div>
                                                                                      <b>SELECCIONE EL TIPO DE TARJETA</b>
                                                                                      <ng-select class="form-control" id="seleccionarCompania" name="seleccionarCompania"
                                                                                        placeholder="Ingrese cédula, nombre, apellido..." style="width: 100%;" name="country"
                                                                                        [(ngModel)]='companiaBancaria'>
                                                                                        <ng-option value="">Seleccione el tipo...</ng-option>
                                                                                        @for (obj of companiasList; track obj) {
                                                                                          <ng-option [value]="obj.COD_TARJE+','+obj.NOM_TARJE">
                                                                                            {{obj.NOM_TARJE}}
                                                                                          </ng-option>
                                                                                        }
                                                                                      </ng-select>
                                                                                    </div>
                                                                                  }

                                                                                  @if (errorTransaccion) {
                                                                                    <div>
                                                                                      <p class="text-danger"><b>ERROR CAPTURADO</b> {{errorCapturado}}</p>
                                                                                    </div>
                                                                                  }




                                                                                </div>
                                                                                <div class="modal-footer">

                                                                                  <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">CANCELAR</button>
                                                                                  <button type="button" class="btn ripple btn-primary"  (click)="guardarTransaccion()" [attr.disabled]="guardandoFacturaPaquete ? true : null">GUARDAR Y GENERAR FACTURA</button>
                                                                                </div>
                                                                              </ng-template>



                                                                              <!-- ----------------------------------------------------------------------- -->
                                                                              <!--                    MODAL BUSCAR INFORMACION PRUEBAS                     -->
                                                                              <!-- ----------------------------------------------------------------------- -->
                                                                              <ng-template #mdlModalInformacionPrueba let-modal>
                                                                                <div class="modal-header">
                                                                                  <h6 class="modal-title">INFORMACION DE PRUEBAS</h6>

                                                                                </div>
                                                                                <div class="modal-body">


                                                                                  @if (spinnerBoolean) {
                                                                                    <div class="text-center">
                                                                                      <hr>
                                                                                        <div class="spinner-grow" role="status">
                                                                                          <span class="sr-only">Loading...</span>
                                                                                        </div>
                                                                                        <p class="text-center">{{cargando}}</p>
                                                                                      </div>
                                                                                    }
                                                                                    <div class="form-group">
                                                                                      <b>PRUEBA</b>
                                                                                      <p>{{txtPruebaInformacion}}</p>

                                                                                    </div>

                                                                                    <div class="form-group">
                                                                                      <b>MUESTRA</b>
                                                                                      <p>{{txtMuestrarInformacion}}</p>

                                                                                    </div>

                                                                                    <div class="form-group">
                                                                                      <b>CONTENEDOR</b>
                                                                                      <p>{{txtContenedor}}</p>

                                                                                    </div>

                                                                                    <div class="form-group">
                                                                                      <b>CONDICION</b>
                                                                                      <p>{{txtCondicion}}</p>

                                                                                    </div>

                                                                                    <div class="form-group">
                                                                                      <b>TIEMPO ENTREGA RESULTADOS EN DIAS</b>
                                                                                      <p>{{txtEntregaResultados}}</p>

                                                                                    </div>



                                                                                  </div>
                                                                                  <div class="modal-footer">

                                                                                    <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">SALIR</button>
                                                                                  </div>
                                                                                </ng-template>


                                                                                <!-- large modal -->
                                                                                <ng-template #modalMultiplesPagos let-modal >
                                                                                  <div class="modal-header">
                                                                                    <h6 class="modal-title">MULTIPLES PAGOS</h6>
                                                                                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                                                                                      <span aria-hidden="true">&times;</span>
                                                                                    </button>
                                                                                  </div>
                                                                                  <div class="modal-body">
                                                                                    @if (spinnerGuardarMP) {
                                                                                      <div class="text-center">
                                                                                        <hr>
                                                                                          <div class="spinner-grow" role="status">
                                                                                            <span class="sr-only">Loading...</span>
                                                                                          </div>
                                                                                          <p class="text-center">Cargando por favor espere...</p>
                                                                                          <br>
                                                                                          </div>
                                                                                        }

                                                                                        <div class="row">
                                                                                          <div class="col-md-3">
                                                                                            <label for="" class="font-weight-bold">METODO DE PAGO:</label>
                                                                                            <select class="form-control" [(ngModel)]='modalMetodoPago'  (change)="showInfoTarjeta($event)" >
                                                                                              <option value="">Seleccione...</option>
                                                                                              <option value="EFECTIVO">EFECTIVO</option>
                                                                                              <option value="TARJETA DE DEBITO">TARJETA DE DEBITO</option>
                                                                                              <option value="TARJETA DE CREDITO">TARJETA DE CREDITO</option>
                                                                                              <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                                                                                              <option value="CREDITO">CREDITO</option>

                                                                                            </select>
                                                                                          </div>
                                                                                          <div class="col-md-3">
                                                                                            <label for="" class="font-weight-bold">IMPORTE:</label>
                                                                                            <input type="text" class="form-control" [(ngModel)]="modalImportePago" (keypress)="soloNumerosPunto($event)">
                                                                                          </div>
                                                                                          @if (mostrarInfoTarjeta) {
                                                                                            <div class="col-md-3">
                                                                                              <label class="font-weight-bold">TIPO DE TARJETA</label>
                                                                                              <ng-select class="form-control"  name="seleccionarCompania"  [(ngModel)]='modalTipoTarjeta' >
                                                                                                <ng-option value="">Seleccione el tipo...</ng-option>
                                                                                                @for (obj of companiasList; track obj) {
                                                                                                  <ng-option [value]="obj.NOM_TARJE">
                                                                                                    {{obj.NOM_TARJE}}
                                                                                                  </ng-option>
                                                                                                }
                                                                                              </ng-select>
                                                                                            </div>
                                                                                          }
                                                                                          <div class="col-md-3">
                                                                                            <p class="font-weight-bold">Acción:</p>
                                                                                            <button type="button" class="btn ripple btn-success  btn-sm" (click)="agregarPagoMultiple()" > <i class="fa fa-plus" aria-hidden="true"></i> Agregar Pago</button>
                                                                                          </div>
                                                                                        </div>
                                                                                        <div class="mt-2">
                                                                                          <div class="table-responsive border">
                                                                                            <table class="table table-bordered table-striped dt-responsive">
                                                                                              <thead>
                                                                                                <tr>
                                                                                                  <th>#</th>
                                                                                                  <th>Importe</th>
                                                                                                  <th>Forma Pago</th>
                                                                                                </tr>
                                                                                              </thead>
                                                                                              <tbody>
                                                                                                @for (pago of arrayPagos; track pago; let i = $index) {
                                                                                                  <tr>
                                                                                                    <th scope="row" (click)="deletePago(i)">
                                                                                                      <i class="fa fa-trash fa-2x text-danger"></i>
                                                                                                    </th>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control" value="{{pago.importe}}" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control"  value="{{pago.metodoPago}}" readonly>
                                                                                                    </td>
                                                                                                  </tr>
                                                                                                }
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </div>

                                                                                        <div class="form-row mt-2">
                                                                                          <div class="col-4">
                                                                                            <label for="" class="font-weight-bold">CANCELADO</label>
                                                                                            <input class="form-control" type="text" [(ngModel)]='valorCancelado'  readonly>
                                                                                          </div>
                                                                                          <div class="col-4">
                                                                                            <label for="" class="font-weight-bold">PENDIENTE</label>
                                                                                            <input class="form-control" type="text" [(ngModel)]='valorPendiente' readonly>
                                                                                          </div>
                                                                                          <div class="col-4">
                                                                                            <label for="" class="font-weight-bold">TOTAL</label>
                                                                                            <input class="form-control" type="text" [(ngModel)]='total'  readonly>
                                                                                          </div>
                                                                                        </div>


                                                                                      </div>
                                                                                      <div class="modal-footer ">
                                                                                        <button type="button" class="btn ripple btn-primary" [disabled]="disabledGuardarMP" (click)="guardarTransaccion()">Guardar</button>
                                                                                      </div>
                                                                                    </ng-template>


                                                                                    <!-- large modal -->
                                                                                    <ng-template #modalOrderPendingPaciente let-modal >
                                                                                      <div class="modal-header">
                                                                                        <h6 class="modal-title">PACIENTE - {{nombre}}</h6>
                                                                                        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                                                                                          <span aria-hidden="true">&times;</span>
                                                                                        </button>
                                                                                      </div>
                                                                                      <div class="modal-body">
                                                                                        <div class="mt-2">
                                                                                          <div class="table-responsive border">
                                                                                            <table class="table table-bordered table-striped dt-responsive">
                                                                                              <thead>
                                                                                                <tr>
                                                                                                  <th>#</th>
                                                                                                  <th>Orden</th>
                                                                                                  <th>Doctor</th>
                                                                                                  <th>Fecha</th>
                                                                                                  <th>Accion</th>
                                                                                                </tr>
                                                                                              </thead>
                                                                                              <tbody>
                                                                                                @for (orden of _ordersPendingPatient; track orden; let i = $index) {
                                                                                                  <tr>
                                                                                                    <td>
                                                                                                      {{i+1}}
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control" value="{{orden.secuencia}}" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control" value="{{orden.doctor}}" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control"  value="{{orden.fecha}}" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <button class="btn btn-primary"  (click)="editOrden(orden.codigo)">Actualizar</button>
                                                                                                    </td>
                                                                                                  </tr>
                                                                                                }
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                      <div class="modal-footer ">
                                                                                        <button type="button" class="btn ripple btn-primary"  (click)="modal.dismiss('Cross click')">Gestionar Nueva</button>
                                                                                      </div>
                                                                                    </ng-template>


                                                                                    <ng-template #modalListaAnalisis let-modal>
                                                                                      <div class="modal-header">
                                                                                        <h6 class="modal-title">SELECCIONE LOS ANALISIS ({{servicioEscodigo}})</h6>
                                                                                        <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                                                          <span aria-hidden="true">&times;</span>
                                                                                        </button>
                                                                                      </div>
                                                                                      <div class="modal-body">

                                                                                        <div class="mt-2">
                                                                                          <div class="table-responsive border">
                                                                                            <table class="table table-bordered table-striped dt-responsive">
                                                                                              <thead>
                                                                                                <tr>
                                                                                                  <th>Seleccionar</th>
                                                                                                  <th>Analisis</th>
                                                                                                </tr>
                                                                                              </thead>
                                                                                              <tbody>
                                                                                                @for (orden of _listadoAnalisis; track orden; let i = $index) {
                                                                                                  <tr>
                                                                                                    <td style="width: 150px;">
                                                                                                      <input type="checkbox" style="width:100%; height: calc(1.5em + .75rem + 2px);" (change)="seleccionaAnalisisCefa($event.target,i,orden.analisis)" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control" value="{{orden.analisis}}" readonly>
                                                                                                    </td>
                                                                                                  </tr>
                                                                                                }
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </div>


                                                                                      </div>
                                                                                      <div class="modal-footer">

                                                                                        <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalOdontograma()">Cerrar</button>
                                                                                        <button type="button" class="btn ripple btn-success" (click)="agregarDetalleAnalisisCefa()" >Aceptar</button>
                                                                                      </div>
                                                                                    </ng-template>



                                                                                    <ng-template #modalSubserviciosCorporal let-modal>
                                                                                      <div class="modal-header">
                                                                                        <h6 class="modal-title">SELECCIONE LOS SUBSERVICIOS ({{servicioEscodigo}})</h6>
                                                                                        <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                                                          <span aria-hidden="true">&times;</span>
                                                                                        </button>
                                                                                      </div>
                                                                                      <div class="modal-body">

                                                                                        <div class="mt-2">
                                                                                          <div class="table-responsive border">
                                                                                            <table class="table table-bordered table-striped dt-responsive">
                                                                                              <thead>
                                                                                                <tr>
                                                                                                  <th>Seleccionar</th>
                                                                                                  <th>Servicios a realizar</th>
                                                                                                </tr>
                                                                                              </thead>
                                                                                              <tbody>
                                                                                                @for (orden of listaSubServiciosCorporal; track orden; let i = $index) {
                                                                                                  <tr>
                                                                                                    <td style="width: 150px;">
                                                                                                      <input type="checkbox" style="width:100%; height: calc(1.5em + .75rem + 2px);" (change)="seleccionaSubserviciosCorporal($event.target,i,orden.id)" readonly>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                      <input type="text" class="form-control" value="{{orden.nombre}}" readonly>
                                                                                                    </td>
                                                                                                  </tr>
                                                                                                }
                                                                                              </tbody>
                                                                                            </table>
                                                                                          </div>
                                                                                        </div>


                                                                                      </div>
                                                                                      <div class="modal-footer">

                                                                                        <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalOdontograma()">Cerrar</button>
                                                                                        <button type="button" class="btn ripple btn-success" (click)="agregarDetalleCorporal()" >Aceptar</button>
                                                                                      </div>
                                                                                    </ng-template>









                                                                                    <!-- ----------------------------------------------------------------------- -->
                                                                                    <!--                       SOLICITUD CAMBIO DE PRECIO                        -->
                                                                                    <!-- ----------------------------------------------------------------------- -->
                                                                                    <ng-template #mdlSolicitarDescuentoMasivo let-modal>
                                                                                      <div class="modal-header">
                                                                                        <h6 class="modal-title">SOLICITUD DESCUENTO %</h6>
                                                                                        <button type="button" class="close" aria-label="Close" (click)="cerrarModalDoctor1()">
                                                                                          <span aria-hidden="true">&times;</span>
                                                                                        </button>
                                                                                      </div>
                                                                                      <div class="modal-body">
                                                                                        @if (spinnerBoolean) {
                                                                                          <div class="text-center">
                                                                                            <hr>
                                                                                              <div class="spinner-grow" role="status">
                                                                                                <span class="sr-only">Loading...</span>
                                                                                              </div>
                                                                                              <p class="text-center">Cargando por favor espere...</p>
                                                                                            </div>
                                                                                          }
                                                                                          <b>DESCUENTO SUGERIDO</b>&nbsp;
                                                                                          <div >
                                                                                            <input type="number" class="form-control"  [(ngModel)]='txtPrecioSugerido' >
                                                                                          </div>
                                                                                          @if (contenedorValidarPrecio) {
                                                                                            <div class="col-lg-12 col-xl-6 col-xxl-12 col-md-12 col-12">
                                                                                              <hr>
                                                                                                <div class="card custom-card">
                                                                                                  <div class="card-body pb-3">
                                                                                                    <p  class="mb-2 tx-12"><b>INGRESE EL CÓDIGO DE VERIFICACIÓN:</b> <input class="form-control" [(ngModel)]='codigoFacturadorValidacion'  type="number"></p>
                                                                                                    <button class="btn btn-success" [disabled]="solicitudPrecioResultado && !solicitudPrecioResultado.aprobado" (click)="validarCodigoMasivo()">VALIDAR</button>
                                                                              <button class="btn btn-outline-primary ms-2" type="button" [disabled]="cargandoCodigosAprobados" (click)="actualizarCodigosAprobadosHoy()">
                                                                                <i class="fa fa-refresh"></i> Actualizar códigos
                                                                              </button>
                                                                              <div class="mt-3">
                                                                                <div class="d-flex justify-content-between align-items-center mb-2">
                                                                                  <b class="tx-12">CÓDIGOS APROBADOS HOY</b>
                                                                                  @if (cargandoCodigosAprobados) {
                                                                                    <small class="text-muted">Actualizando...</small>
                                                                                  }
                                                                                </div>
                                                                                @if (codigosAprobadosHoy.length === 0) {
                                                                                  <small class="text-muted">Sin códigos aprobados para hoy.</small>
                                                                                }
                                                                                @if (codigosAprobadosHoy.length > 0) {
                                                                                  <div class="table-responsive">
                                                                                    <table class="table table-sm table-bordered mb-0">
                                                                                      <tbody>
                                                                                        @for (codigo of codigosAprobadosHoy; track codigo.id) {
                                                                                          <tr>
                                                                                            <td>
                                                                                              <b>{{ codigo.codigo }}</b><br>
                                                                                              <small>{{ codigo.numeroSolicitud }} - {{ codigo.servicio }}</small>
                                                                                              <br>
                                                                                              <small class="text-muted">Solicitud: {{ codigo.fecha | date:'dd/MM/yyyy HH:mm' }}</small>
                                                                                            </td>
                                                                                            <td class="text-end">
                                                                                              <button type="button" class="btn btn-sm btn-outline-success" (click)="usarCodigoAprobado(codigo.codigo)">Usar</button>
                                                                                            </td>
                                                                                          </tr>
                                                                                        }
                                                                                      </tbody>
                                                                                    </table>
                                                                                  </div>
                                                                                }
                                                                              </div>
                                                                                                    <br>
                                                                                                    </div>
                                                                                                  </div>
                                                                                                </div>
                                                                                              }
                                                                                            </div>
                                                                                            <div class="modal-footer">

                                                                                              <button type="button" class="btn ripple btn-secondary"  (click)="cerrarModalDoctor1()">Cerrar</button>
                                                                                              <button type="button" class="btn ripple btn-primary"  (click)="solicitarCambio()">SOLICITAR</button>
                                                                                            </div>
                                                                                          </ng-template>

                                                                                          <!-- ----------------------------------------------------------------------- -->
                                                                                          <!--                    MODAL DOCUMENTOS FACTURA                             -->
                                                                                          <!-- ----------------------------------------------------------------------- -->
                                                                                          <ng-template #mdlDocumentosFactura let-modal>
                                                                                            <div class="modal-header doc-factura-header">
                                                                                              <div class="d-flex align-items-center gap-2">
                                                                                                <i class="fa fa-check-circle fa-2x"></i>
                                                                                                <div>
                                                                                                  <h6 class="modal-title mb-0">¡Orden Facturada!</h6>
                                                                                                  <small class="doc-factura-num">N° {{docNumFactura}}</small>
                                                                                                </div>
                                                                                              </div>
                                                                                            </div>
                                                                                            <div class="modal-body">
                                                                                              <p class="text-muted text-center mb-3">Selecciona el documento que deseas abrir:</p>
                                                                                              <div class="doc-links-list">
                                                                                                @for (link of docLinks; track link) {
                                                                                                  <button type="button" class="btn btn-outline-primary doc-link-btn" (click)="abrirDocumentoFactura(link)">
                                                                                                    <i class="fa {{link.icon}}"></i>
                                                                                                    <span>{{link.label}}</span>
                                                                                                  </button>
                                                                                                }
                                                                                              </div>
                                                                                            </div>
                                                                                            <div class="modal-footer justify-content-center">
                                                                                              <button type="button" class="btn btn-secondary doc-factura-inicio" (click)="irAlInicio()">
                                                                                                <i class="fa fa-home"></i> Ir al Inicio
                                                                                              </button>
                                                                                            </div>
                                                                                          </ng-template>
